import { apiRequest } from '../helpers'

export interface TransparenzChInspectPayload {
  uid: string
  clientId: string
  fiUid: string
  fiPid: string
  languageCode?: 'de' | 'fr' | 'it' | 'en'
}

export interface TransparenzChRecord {
  _id: string
  requestTimestamp: string
  uid: string
  clientId: string
  response: Record<string, unknown> | []
}

export async function inspectTransparenzCh(
  payload: TransparenzChInspectPayload
): Promise<TransparenzChRecord> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/declarations-fi/inspect`, 'POST', payload)
}

export async function getTransparenzChByClientId(clientId: string): Promise<TransparenzChRecord[]> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/declarations-fi/client/${clientId}`, 'GET')
}

export interface TransparenzChConnectionStatus {
  configured: boolean
  needsReauth?: boolean
  clientId?: string
  refreshTokenExpiresAt?: number | null
  updatedAt?: string
}

export async function getTransparenzChConnectionStatus(): Promise<TransparenzChConnectionStatus> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/transparenz-ch/connection/status`, 'GET')
}

export async function saveTransparenzChConnection(payload: {
  clientId: string
  clientSecret: string
  refreshToken: string
}): Promise<{ ok?: boolean; message?: unknown }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/transparenz-ch/connection`, 'POST', payload)
}

export async function deleteTransparenzChConnection(): Promise<{ ok?: boolean }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/transparenz-ch/connection`, 'DELETE')
}
